import React from "react";
import Image from "next/image";

const AvailabilityCalendarButton = ({ calendarRef }) => {
  const handleOpenModal = () => {
    setTimeout(() => {
      if (calendarRef.current) {
        calendarRef.current.scrollIntoView({
          behavior: "smooth",
          block: "end", // Alt kısmı görünür yap
          inline: "nearest",
        });
      }
    }, 100);
  };

  return (
    <button
      type="button"
      className="flex items-center gap-2"
      onClick={handleOpenModal}
    >
      <div className="flex items-center justify-center w-9 h-9 rounded-full bg-white border border-[#E7EDF4]">
        <Image
          src="/icons/card-calendar.svg"
          width={16}
          height={16}
          className="object-contain"
          alt="calendar"
        />
      </div>
      <span className="font-medium text-themeBreadcrumColor text-size-13">
        Müsaitlik Takvimi
      </span>
    </button>
  );
};

export default AvailabilityCalendarButton;
